import { AppInterface } from "@swivl-mono/types";
import { Button, ButtonColor, Spinner } from "@swivl-mono/ui";
import { useSearchParams } from "react-router-dom";
import AppsModel from "../../../../Models/Apps/Apps.Model";
interface Props {
  app: AppInterface
  selected?: boolean
}

export default function GoogleAppView(props: Props) {
  const { app, selected } = props
  let [searchParams, setSearchParams] = useSearchParams();

  const handleChange = e => {
    var token = app.token || {}
    token[e.target.name] = e.target.value;
    app.token = token;
    AppsModel.update(app, false);
  }

  const handleFileChange = e => {
    const fileReader = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = reader => {

      // setFiles(e.target.result);
      if (typeof reader.target?.result === "string") {
        const auth = JSON.parse(reader.target!.result as string);

        var token = app.token || {}
        token.auth = auth;
        app.token = token;
        AppsModel.update(app, true);
      }

    };
  };
  const removeAuth = () => {
    var token = app.token || {}
    token.auth = null;
    app.token = token
    AppsModel.update(app, true);
  }

  if (!app) {
    return <div className="SSMView">
      <Spinner />
    </div>
  }

  const token = app.token || {}
  const hasAuth = token.auth && token.auth.type === "service_account"
  const oAuth = token.oAuth

  return <div className="GoogleAppView">
    {searchParams?.get("error") && <div className="error text-orange-500 py-3">Error: {searchParams?.get("error")}</div>}

    {oAuth ?
      oAuth.refresh_token ?
        <>
          <h3>Access Granted</h3>
          {/* {DateTime.fromMillis(oAuth.expiry_date).toLocaleString(DateTime.DATETIME_MED)} */}
          To reset your access, first remove access here: <a href={`https://myaccount.google.com/permissions?pli=1`} target="_blank">https://myaccount.google.com/permissions?pli=1</a>
          <br />then <a href={`${import.meta.env.VITE_SERVER_URL}/api/google/app/${app.id}/oauth/register`} >Reregister API Access</a>
        </> : <>
          <h3>OAuth Misconfigured</h3>
          Oh no, it looks like your OAuth is misconfigured. You must first reset your account access here: <a href={`https://myaccount.google.com/permissions?pli=1`} target="_blank">https://myaccount.google.com/permissions?pli=1</a>
          <br />and then <a href={`${import.meta.env.VITE_SERVER_URL}/api/google/app/${app.id}/oauth/register`} >Reregister API Access</a>
        </>
      : <>
        <Button
          color={ButtonColor.ORANGE}
          onClick={() => {
            location.href = `${import.meta.env.VITE_SERVER_URL}/api/google/app/${app.id}/oauth/register`
          }}>Register for API Access</Button>
        <br /><br />
      </>
    }
  </div>
}

